import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-partial-refund',
  templateUrl: './create-partial-refund.component.html',
  styleUrls: ['./create-partial-refund.component.css']
})
export class CreatePartialRefundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
